<template>
  <div class="adv_order_transporters_external">
    <div v-if="getExternalTransporterRates && getExternalTransporterRates.length > 0" class="adv_order_transporters_external_rates">
      <div v-for="(rate, index) in getExternalTransporterRates" :key="index" class="custom-control custom-radio">
        <input name="transport_external_rate_id"
               v-bind:value="rate.price"
               @click="onClickExternalRate(rate)"
               @change="onChangeExternalRate(rate)"
               type="radio"
               :id="'eternalRateRadio' + index"
               class="custom-control-input"
               v-model="externalRate"
        >
        <label class="custom-control-label transporter_label" :for="'eternalRateRadio' + index">
          {{ rate.productName }}
          <small>
            <em v-html=" '(' + (rate.price * getSelectedCurrency.rate).toFixed(2) + getSelectedCurrency.symbol + ')' "/>
          </small>
        </label>
      </div>
    </div>
    <div v-else-if="getExternalTransporterRatesLoading" class="adv_order_transporters_external_rates_loader">
      <span class="loader"></span>
    </div>
    <div v-else class="adv_order_transporters_external_rates_empty">
      <p>{{ t('preview.order.transporters.external.rates.empty') }}</p>
    </div>
    <div v-if="selectedTransporterExternalRate" class="adv_order_transporters_external_rates_input">
      <input type="hidden" name="transporterExternalRate" :value="JSON.stringify(selectedTransporterExternalRate)">
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdvOrderTransportersExternal',
  data: () => {
    return {
      externalRate: null
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCurrency',
      'getExternalTransporterRates',
      'getExternalTransporterRatesLoading',
      'getSelectedTransporterExternalRate'
    ]),
    selectedTransporterExternalRate: {
      get () {
        return this.getSelectedTransporterExternalRate
      },
      set (value) {
        this.setSelectedTransporterExternalRate(value)
      }
    }
  },
  methods: {
    ...mapActions(['setSelectedTransporterExternalRate']),
    onClickExternalRate (rate) {
      this.selectedTransporterExternalRate = rate
    },
    onChangeExternalRate (rate) {
      this.selectedTransporterExternalRate = rate
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  position: relative;
  display: grid;
  margin-bottom: 1rem;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 26px;
  height: 26px;
  animation: spin 2s linear infinite;
  justify-items: center;
  align-items: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.adv_order_transporters_external_rates_loader {
  margin-bottom: 1rem;
}
.adv_order_transporters_external_rates_empty {
  background: #f4f4f4;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 1rem;
  p {
    margin: 0;
    padding: 0;
    font-size: 13px;
  }
}
</style>
